import { defineStore } from 'pinia'
import { GoodsItemType, ICartPriceData, IDiscountGoods, IPayMethod } from '@/@types/types'
import { GoodsNavListItemType } from '@/api/types/goodsTypes'

export const useGoodsStore = defineStore('__mall_goods_store', {
  state: (): {
    singleGoods: GoodsItemType[]
    singlePriceData: ICartPriceData | null
    payVisible: boolean
    payPrice: number
    discountPrice: number
    cartGoodsList: GoodsItemType[]
    cartPriceData: ICartPriceData | null
    allDiscountList: GoodsItemType[]
    allGoodsList: GoodsNavListItemType[]
    payMethod: IPayMethod
    currentCartPath: string
    discountGoodsList: IDiscountGoods[]
    openSpokes: boolean
  } => ({
    singleGoods: [],
    singlePriceData: null,
    payVisible: false,
    payPrice: 0,
    discountPrice: 0,
    cartGoodsList: [],
    cartPriceData: null,
    allDiscountList: [],
    allGoodsList: [],
    payMethod: 'cart',
    currentCartPath: '',
    discountGoodsList: [],
    openSpokes: false
  }),
  actions: {
    setSingleGoods(goods: GoodsItemType) {
      this.singleGoods = [goods]
    },
    setPayVisible(visible: boolean) {
      this.payVisible = visible
    },
    setPayMethod(type: IPayMethod) {
      this.payMethod = type
    },
    setCartGoodsList(goodsList: GoodsItemType[]) {
      this.cartGoodsList = goodsList
    },
    setDiscountGoodsList(data: IDiscountGoods[]) {
      this.discountGoodsList = data
    },
    setOpenSpokes(open: boolean) {
      this.openSpokes = open
      console.log('openSpokes', this.openSpokes)
    }
  },
  persist: {
    key: '__mall_goods_hero__',
    storage: localStorage,
    paths: ['cartGoodsList', 'currentCartPath']
  }
})
